import { jsx as _jsx } from "react/jsx-runtime";
import { MULTISELECT_FILTER } from '@as-react/common-types';
import { FilterSelectList } from './FilterSelectList';
export const FilterItemContentMultiSelect = ({ desktop, filter, onFilterItemChange, toggleFilterOptions, }) => (_jsx(FilterSelectList, { toggleFilterOptions: toggleFilterOptions, desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, type: MULTISELECT_FILTER }));
